// src/pages/health/HealthDetail.js
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AppNavbar from "../../components/common/AppNavbar";
import { Container, Card, Spinner } from "react-bootstrap";
import axios from "axios";

const HealthDetail = () => {
  const { topicId } = useParams();
  const [topicDetail, setTopicDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTopicDetail = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `https://health.gov/myhealthfinder/api/v3/topicsearch.json`,
          {
            params: {
              lang: "en",
              topicId: topicId,
              Type: "topic",
            },
          }
        );

        const resource = response.data.Result.Resources.Resource[0];
        setTopicDetail(resource);
      } catch (err) {
        console.error("Error fetching topic detail:", err);
        setError("Failed to load topic details.");
      } finally {
        setLoading(false);
      }
    };

    fetchTopicDetail();
  }, [topicId]);

  if (loading)
    return (
      <div className="text-center my-5">
        <Spinner animation="border" />
        <p>Loading topic details...</p>
      </div>
    );

  if (error) return <div className="text-center text-danger">{error}</div>;

  if (!topicDetail)
    return <div className="text-center">No details available.</div>;

  return (
    <>
      <AppNavbar />
      <Container className="my-4">
        <Card className="shadow">
          {topicDetail.ImageUrl && (
            <Card.Img variant="top" src={topicDetail.ImageUrl} />
          )}
          <Card.Body>
            <Card.Title className="fw-bold">{topicDetail.Title}</Card.Title>
            <Card.Subtitle className="mb-2 text-muted">
              {topicDetail.Categories}
            </Card.Subtitle>
            {topicDetail.Description && (
              <Card.Text>{topicDetail.Description}</Card.Text>
            )}

            {/* Optional: External link */}
            {topicDetail.Url && (
              <a
                href={topicDetail.Url}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                Read Full Details
              </a>
            )}
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default HealthDetail;
